import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { OrderList } from './OrderList'
import { OrderModel } from './models/Order'
import { RootState } from 'setup'
import { actions } from './redux/OrdersRedux'
import { HistoryList } from './HistoryList'

const WidgetsPage: React.FC = (props: any) => {

  const dispatch = useDispatch()
  const orders: OrderModel[] = useSelector<RootState>(({ orders }) => orders.orders, shallowEqual) as OrderModel[] || []
  const role: string = useSelector<RootState>(({ auth }) => auth.user?.role, shallowEqual) as string || ""
  const channel_prior: number = useSelector<RootState>(({ orders }) => orders.channel_prior, shallowEqual) as number || 0
  const [channelPrior, setChannelPrior] = useState(channel_prior)

  const currentOrder: OrderModel = useSelector<RootState>(({ orders }) => orders.currentOrder, shallowEqual) as OrderModel || undefined

  useEffect(() => {
    window.apiAlias = props.apiAlias;
    if(props.match.params.state!=="lich-su"){
      dispatch(actions.requestOrders(props.match.params.state))
    }
  }, [])

  useEffect(() => {
    if(props.match.params.state!=="lich-su"){
      dispatch(actions.requestOrders(props.match.params.state))
    }
  }, [props.match.params.state]);

  useEffect(() => {
    setChannelPrior(channel_prior)
  }, [channel_prior])



  return (
    <>
      <div className='row gy-5 gx-xl-12'>
        <div className='col-xl-12'>
          {
            props.match.params.state === "lich-su" ? <HistoryList apiAlias={props.apiAlias} state={props.match.params.state} className='card-xxl-stretch mb-5 mb-xl-12' />
              : <OrderList apiAlias={props.apiAlias} state={props.match.params.state} orders={orders} className='card-xxl-stretch mb-5 mb-xl-12' />
          }
        </div>
      </div>
    </>
  )
}

export default WidgetsPage
